import { combineReducers } from "redux"
import authenticated from './authenticated';
import signUp from './signUp';
import notification from './notification';
import planDetails from './product_plan_details';
import firstRun from './first_run';
import showPlanSection from './show_modal_section';
import collabratorSection from './collabrator';
import moderation from './moderationReducer';
import accountsReducer from './accountsReducer' 
import wallsReducer from './wallsReducer'
import loaderReducer from './loaderReducer'
import appsMore from "./appsMore";
import Publish from "./Publish";
import wallData from './wallData';
import EmailCampaigns from './EmailCampaigns';
import addFeedReducer from './addFeedReducer';
import manageFeedsReducer from './manageFeedsReducer'

// STUDIO START
import studio from './studio/studioReducer'
import scene from './studio/sceneReducer'
import layout from './studio/layoutReducer'
import wallStudio from './studio/wallReducer'
import apps from './studio/appsReducer'
import quote from './studio/quoteReducer'
import quoteData from './studio/quoteDataReducer'
import protectedWall from './studio/protectedReducer'

//analytics
import analyticwall from './analytics/analyticWallReducer';
import analyticsStatus from './analytics/analyticsStatusReducer'
import wallRefresh from './analytics/refreshReducer'
import dashboardDisplayReducer from './analytics/dashboardReducer';
import post_week from './analytics/dashboardReducer'
import socail_data from './analytics/dashboardReducer'
import displayModalSection from './analytics/showDisplayModal';
import analyticwallD from './analytics/analyticWallReducer';
import analyticsStatusD from './analytics/analyticsStatusReducer'; 
import analyticsRecords from './analytics/analyticsRecords'

export default combineReducers({
    signUp,
    authenticated,
    notification,
    planDetails,
    firstRun,
    showPlanSection,
    collabratorSection,
    moderation,
    userAccountData: accountsReducer,
    wallReducer: wallsReducer,
    loader: loaderReducer,
    appsMore,
    Publish,
    addFeedReducer,
    wallData: wallData,
    manageFeeds: manageFeedsReducer,
    EmailCampaigns:EmailCampaigns,


    //analytics
    analyticwall: analyticwall,
    analyticsStatus: analyticsStatus,
    wallRefresh: wallRefresh,
    dashboardDisplayReducer: dashboardDisplayReducer,
    post_week: post_week,
    socail_data: socail_data,
    displayModalSection,
    analyticwallD: analyticwallD,
    analyticsStatusD: analyticsStatusD,
    analyticsRecords : analyticsRecords,

     // STUDIO START
     studio: studio,
     scene: scene,
     layout: layout,
     wallStudio: wallStudio,
     apps: apps,
     quote: quote,
     quoteData: quoteData,
     protectedWall: protectedWall
});
